import axios from 'axios'
import { storeToRefs } from 'pinia'
import useAuthStore from '@/store/auth'

const axiosDocumentIns = axios.create({
  baseURL: process.env.VUE_APP_DOCUMENT,
  // baseURL: 'https://localhost:7000/api/',
})

axiosDocumentIns.interceptors.request.use(
  config => {
    const { accessTokenFlow } = storeToRefs(useAuthStore())

    if (accessTokenFlow.value) return { ...config, headers: { Authorization: `Bearer ${accessTokenFlow.value}` } }

    return config
  },
  error => Promise.reject(error),
)

export default axiosDocumentIns
